import React from "react";

import { WorkOrdersContextProvider } from "../../hooks";
import WorkOrdersContent from "./WorkOrdersContent";

export const WorkOrdersPage = () => {
  return (
    <WorkOrdersContextProvider>
      <WorkOrdersContent />
    </WorkOrdersContextProvider>
  );
};

export default WorkOrdersPage;
